<template>
  <div class="columns is-multiline">
    <div class="column is-12 has-text-primary is-italic is-size-5 pdb-0">
      {{ $t('detailOrdreTravailTech.patrimoine.emplacement.champs.title') }}
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.emplacement.champs.natureSol')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ emplacementTechnique.natureSol }}
            </span>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.emplacement.champs.codeBarre')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ emplacementTechnique.codeBarre }}
            </span>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine' +
       '.emplacement.champs.degreDeniveleTerrain')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ emplacementTechnique.degreDeniveleTerrain }}
            </span>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.emplacement.champs.accesSiteSurRdv')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ emplacementTechnique.accesSiteSurRdv ? $t('general.oui') :  $t('general.non') }}
            </span>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.emplacement.champs.acces')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ emplacementTechnique.acces }}
            </span>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.emplacement.champs.groupeDhabitation')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ emplacementTechnique.groupeDhabitation }}
            </span>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.emplacement.champs.numUg')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ emplacementTechnique.numUG }}
            </span>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field :label="$t('detailOrdreTravailTech.patrimoine.emplacement.champs.quartier')"
               custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ emplacementTechnique.quartier }}
            </span>
      </b-field>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    emplacementTechnique: {
      type: Object,
      required: true,
    },
  },
};

</script>
